import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './assets/css/bootstrap.min.css'
//import './assets/css/flat-ui.css'
import './assets/css/dist/gophish.css'
import './assets/css/spark.css'

createApp(App).use(store).use(router).mount('#app')

